<template>
    <div
    class="modal right fade trader-info"
    id="trader-info"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"       
    >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">Preview</h5>
            <button type="button" class="close"  @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <form>
                <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                <h3 v-if="!pdfUrl && !loading" class="text-center">No data available</h3>
                <div class="form-row" v-if="pdfUrl">
                    <embed v-bind:src="pdfUrl" width="800px" height="500px" />
                </div>    

                <br>
                <div class="modal-footer bid">
                    <button type="button" class="btn btn-secondary"  @click="$emit('close')">Close</button>
                    <button :disabled="!pdfName" type="button" @click="sendEmail()"  class="btn btn-primary">SEND TO CUSTOMER</button>
                </div>
            </form>
        </div>
        </div>
    </div>
    </div>
</template>

    <script>
    import authService from "@/authService";
    import config from "@/config";

    export default {
        name: 'modal',
        components :{
            
        },
        props: ['customerData'],
        data() {
            return {
                loading : false,
                pdfUrl : "",
                pdfName : null,
                s3Key : null
            };
        },
        methods: {   
            sendEmail(){
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken()  }
                };
                this.$http
                .post(config.baseUrlBidSide + "/send-customer-quote-end-of-day",
                {
                    "customerId":this.customerData.id,
                    "previewName": this.pdfName,
                    "s3Key" : this.s3Key,
                    "createdById": authService.getUser().id
                }, 
                auth)
                .then(() => {
                    this.loading = false; 
                    this.$alert("Email sent successfully ","","success");             
                    this.$emit('close');               
                })
                .catch(() => {
                    this.loading = false;              
                });
                
            }, 
            getPdf(){
                ///preview-quote-end-of-day/{customer-id}
                 this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken()  }
                };
                this.$http
                .get(config.baseUrlBidSide + "/preview-quote-end-of-day/"+this.customerData.id, auth)
                .then((result) => {
                    this.pdfUrl     = result.data.url;
                    this.pdfName    = result.data.previewName;
                    this.s3Key      = result.data.s3Key;
                    this.loading    = false; 
                   
                })
                .catch(() => {
                    this.loading = false;              
                });
            }     
        },
        created(){
            this.getPdf();
            console.log(this.customerData)
        }
    };
    </script>